import { ReactElement, forwardRef } from 'react';

import { cn } from '@componentLibrary/utils';

interface IconButtonProps {
    className?: string;
    children: ReactElement;
    onClick?: () => void;
    disabled?: boolean;
    'data-testid'?: string;
    'aria-pressed'?: boolean;
}

// This is a really basic implementation - update this incrementally based on use case
const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
    (
        {
            children,
            className,
            onClick,
            disabled = false,
            'data-testid': dataTestId,
            'aria-pressed': ariaPressed,
        },
        ref,
    ) => {
        return (
            <button
                ref={ref}
                className={cn(
                    'flex bg-transparent outline-none border-none rounded-full cursor-pointer p-2 hover:bg-[#e9edf3]',
                    disabled && 'opacity-50 cursor-not-allowed pointer-events-none',
                    className,
                )}
                onClick={disabled ? undefined : onClick}
                disabled={disabled}
                type="button"
                data-testid={dataTestId}
                aria-pressed={ariaPressed}
            >
                {children}
            </button>
        );
    },
);

IconButton.displayName = 'IconButton';

export default IconButton;
